export default __webpack_public_path__ + "static/media/conversation2x.c38d08ad.png";